import { useGetCompanyConfigQuery } from '@graphql/generated/graphql';
import { buildCompanyConfig } from '@lib/config/getCompanyConfig';
import { useRouter } from 'next/router';

export const useCompanyConfig = () => {
    const { locale, query } = useRouter();
    const { data } = useGetCompanyConfigQuery({
        variables: { locale, slug: query.company as string },
    });
    return buildCompanyConfig(data);
};
